export default __webpack_public_path__ + "static/media/tender.c231f9bf.svg";